import React from 'react';

/**
 * Shared wrapper for the stroke icons used on the waitlist page.
 * Icons are decorative, so they are hidden from assistive technologies.
 *
 * @param {Object} props
 * @param {string?} props.className add more style rules
 * @param {number?} props.strokeWidth stroke width in viewBox units
 * @param {ReactNode} props.children SVG shapes
 * @returns {JSX.Element} SVG icon
 */
const StrokeIcon = props => {
  const { className, strokeWidth = 1.75, children } = props;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
};

export const IconHome = props => (
  <StrokeIcon {...props}>
    <path d="M2.5 10.2a2 2 0 0 1 .7-1.52l7.5-6.3a2 2 0 0 1 2.6 0l7.5 6.3a2 2 0 0 1 .7 1.52V19a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2z" />
    <path d="M9.5 21v-6.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V21" />
  </StrokeIcon>
);

export const IconGuests = props => (
  <StrokeIcon {...props}>
    <circle cx="12" cy="7" r="3.25" />
    <path d="M6.75 20.25v-1.5a5.25 5.25 0 0 1 10.5 0v1.5" />
    <circle cx="5" cy="9.25" r="2.25" />
    <path d="M1.5 19.25v-.75a3.5 3.5 0 0 1 3.5-3.5h1" />
    <circle cx="19" cy="9.25" r="2.25" />
    <path d="M22.5 19.25v-.75a3.5 3.5 0 0 0-3.5-3.5h-1" />
  </StrokeIcon>
);

export const IconMail = props => (
  <StrokeIcon {...props}>
    <rect x="2.75" y="4.75" width="18.5" height="14.5" rx="2" />
    <path d="m3.25 6.5 7.6 5.8a1.9 1.9 0 0 0 2.3 0l7.6-5.8" />
  </StrokeIcon>
);

export const IconCalendar = props => (
  <StrokeIcon {...props}>
    <rect x="3" y="4.5" width="18" height="16.5" rx="2" />
    <path d="M3 9.5h18" />
    <path d="M8 2.5v4" />
    <path d="M16 2.5v4" />
  </StrokeIcon>
);

export const IconMapPin = props => (
  <StrokeIcon {...props}>
    <path d="M19.5 10c0 5.1-5.6 10.3-7.1 11.6a.6.6 0 0 1-.8 0C10.1 20.3 4.5 15.1 4.5 10a7.5 7.5 0 0 1 15 0" />
    <circle cx="12" cy="10" r="2.75" />
  </StrokeIcon>
);

export const IconShieldCheck = props => (
  <StrokeIcon {...props}>
    <path d="M20 12.5c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.68 0C7.5 20 4 17.5 4 12.5V5.6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.4 17 4.6 19 4.6a1 1 0 0 1 1 1z" />
    <path d="m8.75 12 2.25 2.25 4.25-4.5" />
  </StrokeIcon>
);
